import { FullStoryWrapper } from '@/logging/FullStoryWrapper';

const fullStory = new FullStoryWrapper();

export default fullStory;
